export default defineNuxtPlugin({
  parallel: true,
  dependsOn: ['i18n:plugin'],
  setup() {
    const userStore = useUserStore();
    const { setAffinityCookie } = useAffinityCookie();

    watch(
      () => userStore.tealiumAudiences,
      (newAffinity) => {
        if (Array.isArray(newAffinity)) {
          setAffinityCookie(newAffinity);
        }
      },
      { immediate: true },
    );
  },
});
